import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import OurIdentityImg1 from "../../assets/img/about/our-identity-img-1.jpg";
// import OurIdentityImg2 from '../../assets/img/about/our-identity-img-2.jpg';

import { useLocation } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function AboutIdentity({ id, scrollToSection, data }) { 

  const location = useLocation();
  
    useEffect(() => {
      // Handle scrolling to this section if the hash matches
      if (location.hash.replace("#", "") === id && scrollToSection) {
        scrollToSection();
      }
    }, [location.hash, id, scrollToSection]);


  return (
   
      <section
        className="about-identity-sec about-developer-sec"
        id={id}
      >
        <Container fluid>
          <Row className="banner-text-center">
            <Col md={6}>
              <div className="heading-div">
                <h2 className="common-head darkGrey" data-aos="fade-up">
                  {data.title}
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="flex-center about-our-identity-row">
            <Col md={6}>
              <img
                src={apiUrl.apiUrl + `/` + data.section_image}
                className="img-fluid"
                alt="Marquis Property Dubai"
                data-aos="fade-up"
              />
            </Col>
            <Col md={6}>
              <div className="about-investing-content-div" data-aos="fade-left">
                <h3 className="common-head goldenColor">
                  {data.section_title}
                </h3>
                <p className="common-para">
                  {data.section_description}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
 
  );
}
export default AboutIdentity;
